<template lang="html">
    <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center">
            <div class="row g-0 align-self-center align-items-center justify-content-center">
                <div class="cta-3 text-primary">Signalement Envoyé</div>
            </div>


            <button  @click="delete_state()" type="button" class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-auto" ><i class="bi-trash"></i></button>
        </div>
        <div class="text-alternate"> Envoyé {{ human_created_on }}</div>

    </div>
</template>

<script>
import moment from "moment";
moment.locale("fr");

export default {
  name: "StateSignalingSent",
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  computed: {
    human_created_on() {
      return moment(this.context.created_on).fromNow();
    }
  },
  mounted() {
    let level = "default";
    const now = moment();
    const elapsed_days = moment.duration(now.diff(this.context.created_on)).as("days");
    if (elapsed_days > 2) level = "warning";
    if (elapsed_days > 5) level = "danger";
    this.$emit("state:set_level", level);
  },
  methods: {
    delete_state() {
      this.$emit("state:delete_state");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
